import React, { useContext} from 'react'
import Box from '@mui/material/Box'
import Rating from '@mui/material/Rating'
import StarIcon from '@mui/icons-material/Star'
import { CompRating } from './../../pages/About/About'

const labels = {
  2: 'Poor+',
  2.5: 'Ok',
  3: 'Ok+',
  3.5: 'Good',
  4: 'Good+',
  4.5: 'Excellent',
  5: 'Excellent+'
}

export default function RatingComponent () {
  const dataArray = useContext(CompRating)
  const ratingValue = dataArray[dataArray.length -1]
  const value = ratingValue
  return (
    <Box
      sx={{
        width: 200,
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <Rating
        name='text-feedback'
        value={value}
        readOnly
        precision={0.5}
        emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize='12px' />}
      />
      <br />
      <Box sx={{ ml: 2 }}>{labels[value]}</Box>
    </Box>
  )
}
